import {Injectable, signal} from '@angular/core';
import {SendToIgnoreNamespace} from "shared/commands";
import {removeElementFromArray} from "shared/utils";
import {TransportService} from "./transport.service";
import {RemoteCommandService} from "./remote.command.service";

@Injectable({
    providedIn: 'root'
})
export class IgnoredUsersService {

    private ignoredUsers: Array<String> = Array();

    //всегда говорим что объекты разные чтоб не было "затыков" если блокируем и разблокируем одного и того же юзера
    public onChange = signal('', {equal: () => false})

    constructor(private remoteCommandService: RemoteCommandService) {
    }

    ignoreUser(userLogin: string) {
        if (this.ignoredUsers.indexOf(userLogin) === -1) {
            this.ignoredUsers.push(userLogin);
            this.remoteCommandService.ignoreUser(userLogin)
            this.onChange.set(userLogin)
        }
    }

    notIgnoreUser(userLogin: string) {
        removeElementFromArray(this.ignoredUsers, userLogin);
        this.onChange.set(userLogin)
    }

    swapIgnoreUser(userLogin: string) {
        if (this.ignoredUsers.indexOf(userLogin) === -1) {
            this.ignoreUser(userLogin)
        } else {
            this.notIgnoreUser(userLogin)
        }

    }

    isUserIgnored(userLogin: String) {
        //TODO:  Сделать бы так чтоб нельзя было игнорировать админов
        return this.ignoredUsers.indexOf(userLogin) !== -1;
    }
}
